import { c as _c } from "react/compiler-runtime";
import { Box, Divider, Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import { Icon } from '@/components/shared/icon';
import { getTestId } from './panelWrapper';
export interface PanelHeaderProps {
  onClose?: () => void;
  onBack?: () => void;
  hideBorder?: boolean;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  alignTitles?: boolean;
  testIdPrefix?: string;
  fullWidthSubtitle?: boolean;
}
export const PanelHeader = props => {
  const $ = _c(29);
  const {
    title,
    subtitle,
    actions,
    testIdPrefix,
    onClose,
    onBack,
    hideBorder,
    alignTitles,
    fullWidthSubtitle: t0
  } = props;
  const fullWidthSubtitle = t0 === undefined ? true : t0;
  let t1;
  if ($[0] !== onBack) {
    t1 = onBack && <Icon data-testid="header-back-button" iconClass="material-symbols-chevron-left-rounded" className="cursor-pointer" onClick={onBack} />;
    $[0] = onBack;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== testIdPrefix || $[3] !== title) {
    t2 = typeof title === "string" ? <Typography variant="h3" data-testid={getTestId(testIdPrefix, "side-panel-title")}>{title}</Typography> : title;
    $[2] = testIdPrefix;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <Stack className="flex-1">{t2}</Stack>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <Stack alignItems="center" direction="row" className="flex-1" gap="12px">{t1}{t3}</Stack>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onClose || $[11] !== testIdPrefix) {
    t5 = onClose && <Icon onClick={onClose} iconClass="material-symbols-close-rounded" data-testid={getTestId(testIdPrefix, "side-panel-close-button")} />;
    $[10] = onClose;
    $[11] = testIdPrefix;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== actions || $[14] !== t5) {
    t6 = <div className="flex gap-4 items-center">{actions}{t5}</div>;
    $[13] = actions;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t6) {
    t7 = <Stack justifyContent="space-between" direction="row" alignItems="center" padding="16px 24px">{t4}{t6}</Stack>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== alignTitles || $[20] !== fullWidthSubtitle || $[21] !== subtitle) {
    t8 = subtitle && <Box className={classnames([{
      "ml-[24px]": alignTitles,
      "ml-[40px]": !alignTitles,
      "max-w-[580px]": !fullWidthSubtitle
    }, "mb-[20px] mt-[8px] mr-[24px]"])}>{typeof subtitle === "string" ? <Typography variant="body1">{subtitle}</Typography> : subtitle}</Box>;
    $[19] = alignTitles;
    $[20] = fullWidthSubtitle;
    $[21] = subtitle;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== hideBorder) {
    t9 = !hideBorder && <Divider />;
    $[23] = hideBorder;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t10 = <Stack>{t7}{t8}{t9}</Stack>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};